import { createContext } from 'react';

import type { ClauseLibraryContextValue as CtxType } from '.';

export default createContext<CtxType>({} as CtxType);
